import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

// Configuration vue gtag
Vue.use(VueGtag, {
  config: {
    id: 'UA-155394870-2'
  }
})

new Vue({
  router,
  store,
  vuetify,
  beforeCreate: function () {
    let urlparams = new URLSearchParams(location.search)
    if (urlparams.has('b')) {
      this.$store.commit('setCustomerStyle', window.atob(this.$route.query.b))
    }
    if (Array.from(urlparams).length >= 2 &&
      urlparams.has('b') &&
      urlparams.has('ref')
    ) {
      let linkquerydata = {
        bdkkenn: window.atob(this.$route.query.b),
        refAuftNr: this.$route.query.ref
      }

      if (linkquerydata.refAuftNr !== '' &&
            (linkquerydata.bdkkenn != null && linkquerydata.bdkkenn !== '')) {
        this.$store.commit('setOrderData', linkquerydata)
        this.$store.dispatch('getTrackAndTraceData')
      } else {
        for (var key in linkquerydata) {
          if (linkquerydata[key] === null || linkquerydata[key] === '') {
            this.$gtag.event('missing request Info', {
              'event_category': 'URL Param Error',
              'event_label': key,
              'value': 1
            })
          }
        }
      }
    } else {
      this.$gtag.event('missing URL Param', {
        'event_category': 'URL Param Error',
        'event_label': Array.from(urlparams).toString(),
        'value': Array.from(urlparams).length
      })
    }
  },
  mounted () {
    if (!Object.keys(this.$store.state.ttlinkquerydata).length > 0) {
      router.push('search' + '?' + new URLSearchParams(location.search))
    }
  },
  render: h => h(App)
}).$mount('#app')
